import { Injectable } from "@angular/core";
import { PlatformService, PlatformResult, API_RESULT_STATUS } from './platform.service';
import { GeolocationPoint, DeviceInfos, DownloadUpdatesInfos, AppInfos, UploadLocalDatabaseInfos, UpdateInfos } from 'src/app/app.models';
import * as moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { APP_MODE } from 'src/app/app.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PlatformWebService extends PlatformService {
    locationWatcherID: number;

    constructor(
        private _httpClient: HttpClient,
        private _apiService: ApiService
    ) {
        super();
    }

    get AppMode(): APP_MODE {
        const lsAppModeStr = localStorage.getItem(environment.LS_ABWORKFLOW_CORE_APP_MODE);
        let parsedAppMode = APP_MODE.ONLINE_MODE;
        if (!!lsAppModeStr && lsAppModeStr !== 'undefined' && lsAppModeStr !== 'null') { 
            parsedAppMode = parseInt(lsAppModeStr) == APP_MODE.OFFLINE_MODE ? APP_MODE.OFFLINE_MODE : APP_MODE.ONLINE_MODE;
        }
        return parsedAppMode;
    }
    get AppVersion(): AppInfos {
        const lsAppVersionStr = localStorage.getItem(environment.LS_ABWORKFLOW_APP_VERSION);
        let parsedAppVersion: any = { APP_VERSION_ID: '0.0.0', APP_VERSION_DISPLAY: '', APP_COMMIT_SHA: '' };
        if (!!lsAppVersionStr && lsAppVersionStr !== 'undefined' && lsAppVersionStr !== 'null') {
            try {
                parsedAppVersion = JSON.parse(lsAppVersionStr);
            } catch(e) {
            }
        }

        return parsedAppVersion;
    }

    getAppVersion(): Promise<AppInfos> {
        return new Promise((resolve, reject) => {
            if (this.AppMode == APP_MODE.ONLINE_MODE) {
                this._httpClient.get<AppInfos>(this._apiService.endPoints.GetAppVersion)
                .subscribe(_appVersions => {
                    resolve(_appVersions);
                }, (_error) => {
                    reject(_error);
                });
            } else {
                resolve(this.AppVersion)
            }
        });
    }

    deviceId(): string {
        return null;
    }

    showNotification(title: string, message: string) {
        if(!('Notification' in window)){
            console.error('Web Notification not supported');
            return;
        }
        Notification.requestPermission((permission) => {
            new Notification(title,{body:message ,icon:'https://abworkflow.com/ui/abw-classic.png', dir:'auto'});
        });
    }

    scanQRCode(): Promise<string> {
        return new Promise((resolve, reject) => reject("QR Code Scanner not supported"));
    }

    takePhoto(): Promise<string> {
        return new Promise((resolve, reject) => reject("Camera not supported"));
    }

    scanDocument(): Promise<string> {
        return new Promise((resolve, reject) => reject("Document Scanner not supported"));
    }

    famocoScanLaser(): Promise<string> {
        return new Promise((resolve, reject) => reject("Famoco Scan Laser not supported"));
    }

    getDeviceInfos(): Promise<DeviceInfos> {
        return new Promise((resolve, reject) => reject("Device Infos only available on Android"));
    }

    printDocument(_filename: string, _html: string, openAfterPrint: boolean) {
        /*const mywindow = window.open('', 'PRINT', 'width=1023,height=1000');
        mywindow.document.write(_html);
        mywindow.document.close();
        mywindow.focus();
        setTimeout(() => {
            mywindow.print();
            mywindow.close();
        }, 400);*/

        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = _html;
        tempDiv.style.cssText = `background: #FFF;
                                    position: absolute;
                                    left: 0;
                                    right: 0;
                                    top: 0;
                                    height: 100%;
                                    color: #000;`;
        document.body.appendChild(tempDiv); // requis pour que jsPDF puisse le rendre
    }

    getCurrentLocation(): Promise<GeolocationPoint> {
        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
              navigator.geolocation.getCurrentPosition((position)=>{
                const longitude = position.coords.longitude;
                const latitude = position.coords.latitude;
                const accuracy = position.coords.accuracy;
                const dateLocation = moment().format("YYYY-MM-DD HH:mm:ss");
                resolve({ longitude: longitude, latitude: latitude, accuracy: accuracy, dateLocation: dateLocation });
              }, (err) => {
                console.log(err);
                reject(err);
              }, { enableHighAccuracy: true });
            } else {
              reject('La géolocalisation n\'est pas disponible.');
            }
        });
    }

    startListenLocation(): Promise<void> {
        return new Promise((resolve, reject) => {
            if (navigator.geolocation) {
              navigator.geolocation.clearWatch(this.locationWatcherID);
              this.locationWatcherID = navigator.geolocation.watchPosition((position) => {
                this.lastKnownLocation.next({ latitude: position.coords.latitude, longitude: position.coords.longitude, accuracy: position.coords.accuracy, dateLocation: moment().format("YYYY-MM-DD HH:mm:ss") });
              }, (err) => {
                console.log(err);
                reject(err);
              }, { enableHighAccuracy: true, timeout: 60000 });
              resolve(null);
            } else {
              reject('La géolocalisation n\'est pas disponible.');
            }
        });
    }
    
    stopListenLocation() {
        navigator.geolocation.clearWatch(this.locationWatcherID);
    }

    downloadUpdates(downloadInfos: DownloadUpdatesInfos): Promise<void> {
        return new Promise((resolve, reject) => resolve());
    }

    uploadLocalDatabase(uploadLocalDatabaseInfos: UploadLocalDatabaseInfos): Promise<void> {
        return new Promise((resolve, reject) => resolve());
    }

    installLatestUpdate(updateInfos: UpdateInfos) {
        return this._httpClient.post<void>(this._apiService.endPoints.UpdateApp, { }).toPromise();
    }

    scanBTDevices(): void {

    }

    connectBTDevice(macAddress: string) {
    }

    disconnectBTDevice() {
    }

    printBTTicket(template: string, datas: any) {
    }

    newlandStartScan(): Promise<string> {
        return new Promise((resolve, reject) => reject("Famoco Scan Laser not supported"));
    }
}